<div class="checkout_wrap" id="scrolltoposition">
    <div class="topprogressbr">
        <div class="container">
            <div class="progress_top">
                <ul>
                    <li class="active" [ngClass]="{ showIcon: steps > 0}">
                        <span>
                            Basic Information 
                        </span>
                    </li>
                    <li class="dotted"   [ngClass]="{ active: steps > 0}"></li>
                    <li class="active"  [ngClass]="{ showIcon: steps === 4}">
                        <span>
                            Coverage  
                        </span>
                    </li>
                    <li class="dotted" [ngClass]="{ active: steps === 4}"></li>
                    <li  [ngClass]="{ showIcon: steps === 4 , active:  steps === 4 }">
                        <span>
                            You’re Covered
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    
   
    <div class="container">
        <div class="bc_btnprt">
            <button mat-button class="can-button" (click)="handleGoBack()">
                <mat-icon>keyboard_backspace</mat-icon>
                Back
              </button>
        </div>
        
        <div class="step_wrap">

                <!-- STEP 1 -->

               <div class="step step1" *ngIf="steps === 1">
                <form [formGroup]="planForm">

                    <div class="property_choosearea">
                        
                        <ul>
                            <li>
                                <div class="ribon">
                                    Most popular
                                </div>
                                <input type="radio" formControlName="planType" value="PAY MONTHLY" (change)="onPlanChange($event)"/>
                                <label>
                                    Monthly Program <br>
                                    <p>
                                        No contract, pay as you go.
                                    </p>
                                </label>
                            </li>
                            <li>
                               
                                <input type="radio" formControlName="planType" value="PAY ANNUALLY" (change)="onPlanChange($event)"/>
                                <label>
                                    Yearly Program
                                    <p>
                                        Save more by paying for the year and enjoy an extra month free. No contract, Cancel anytime.
                                    </p>
                                </label>
                            </li>
                            <li>
                                <div class="ribon">
                                    Best value
                                </div>
                                <input type="radio" formControlName="planType" value="PAY FOR 3 YEARS" (change)="onPlanChange($event)"/>
                                <label>
                                    Signature Program
                                    <p>
                                        Save more with {{this.checkoutService.getSignaturePlanPaload(this.planForm.value.signaturePlan)}} signature plan and enjoy an additional free months, along with roof leak repair coverage. Benefit from locked-in rates for life and the flexibility to cancel anytime.
                                    </p>
                                </label>
                            </li>
                            
                        </ul>
                    </div>

                    <div class="planprt">
                        <h3>Select A Plan</h3>
                        <div class="twoprt">
                            <div class="leftcopayprt">
                                <div class="copayprt" *ngIf="!isCoverageInfo">
                                    <span>
                                        <mat-icon>access_time</mat-icon>
                                        Waiting Period
                                    </span>
                                    
                                    <div class="accessprt">
                                        <form [formGroup]="waitingPeriodForm" class="position-relative">
                                            <input type="text" formControlName="waitingPeriod"  mask="0||00||000"> 
                                            <div class="prefixprt">
                                                Days
                                            </div>
                                         
                                            <mat-error *ngIf="waitingPeriodForm.controls['waitingPeriod'].touched && waitingPeriodForm.controls['waitingPeriod'].hasError('required')">
                                               This is required.
                                            </mat-error>
                                            <mat-error *ngIf="waitingPeriodForm.controls['waitingPeriod'].touched && waitingPeriodForm.controls['waitingPeriod'].hasError('min')">
                                                Minimum value should be 0.
                                             </mat-error>
                                        </form>
                                        <div class="effective_baper">
                                            <label>Effective Date:</label><span>{{waitingPeriodDate | date:'MM/dd/YYYY'}}</span>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                                <div class="copayprt">
                                    <span>
                                        <mat-icon>assignment</mat-icon>
                                       Coverage Term
                                    </span>
                                    <small class="edit" (click)="openCoverageTernModal(planForm)">
                                        <mat-icon>edit</mat-icon> Edit
                                    </small>
                                     <div class="accessprt">
                                        <div *ngIf="planForm.value?.planType !== 'PAY MONTHLY'" class="relative">
                                            <input type="text"  placeholder="Free Months" formControlName="freeMonth"  mask="0||00" required>
                                            <div class="prefixprt">
                                               Free Months
                                            </div>
                                       </div>
                                    </div>
                                    <div *ngIf="planForm.value.planType !=='PAY FOR 3 YEARS'" class="value_area">
                                        <small *ngIf="planForm.value?.planType === 'PAY MONTHLY'">Monthly</small>
                                        <small *ngIf="planForm.value?.planType === 'PAY ANNUALLY'" style="margin-top: 10px;">1 Year</small>
                
                                    </div>
                                   
                                    <!-- <div class="copayselectprt">
                                        <span *ngFor="let item of copayFeeSettings">
                                            <input type="radio" formControlName="copyFee" value="{{item?.amount}}" (change)="handleCopayValueChange(item.reflectedAmount)" />
                                            <label>${{item?.amount}}</label>
                                        </span>
                                    </div> -->
                                    <div class="signature_prt" *ngIf="planForm.value.planType ==='PAY FOR 3 YEARS'">
                                        <mat-radio-group formControlName="signaturePlan" (change)="onPlanChange({target:{value: $event.value}})">
                                            <mat-radio-button value="displayTwoYearlyPrice">2 Years</mat-radio-button>
                                            <mat-radio-button  value="displayThreeYearlyPrice">3 Years</mat-radio-button>
                                            <mat-radio-button  value="displayFourYearlyPrice">4 Years</mat-radio-button>
                                            <mat-radio-button  value="displayFiveYearlyPrice">5 Years</mat-radio-button>
                                          </mat-radio-group>
                                    </div>
                           
                                </div>

                                <div class="copayprt mobnone">
                                    <span>
                                        <mat-icon>room</mat-icon>
                                        Your address
                                    </span>
                                    <p>
                                        {{formatAddress(addressInfo)}}
                                    </p>
                                    <small (click)="openChangeAddressModal(addressInfo)" class="edit">
                                        Change address
                                    </small>
                                </div>
                                <div class="copayprt mobnone">
                                    <span>
                                        Property Size
                                    </span>
                                    <p>
                                        {{PropertyTypeSizeForm.value.propertySize}}  
                                    </p>
                                    <span>
                                        Property Type
                                    </span>
                                    <p>
                                        {{PropertyTypeSizeForm.value.propertyType}}
                                    </p>
                                    <small (click)="openChangePropertyModal()" class="edit">
                                        <mat-icon>edit</mat-icon> Edit
                                    </small>
                                </div>
                                
                                
                                <div class="copayprt">
                                    <span>
                                        <mat-icon> money</mat-icon>
                                        Your Copay Fee
                                    </span>
                                    <p>
                                        Select your Copay Fee when filing a claim.  <a (click)="openCopayFeeModal('Check')">Learn more...</a>
                                    </p>
                                    <div class="copayselectprt">
                                            <span *ngFor="let item of copayFeeSettings">
                                                <input type="radio" formControlName="copyFee" value="{{item?.amount}}" (change)="handleCopayValueChange(item?.reflectedAmount)" />
                                                <label>${{item?.amount}}</label>
                                            </span>
                                    </div>
                                </div>
                            </div>
                            <div class="rightplanbox">
                                <div class="plan_wrap">
                                    <div class="checkout_planbox" *ngFor="let item of planPrice" (click)="handlePlanSelection(item)">
                                        <input type="radio" formControlName="planPriceId" [value]="item?.planPriceId"/>
                                        <div class="border"></div>
                                        <div class="check_front" *ngIf="item.showFrontPanel">
                                            
                                            <div class="plan_typeselector">
                                                <span *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                                                    Monthly
                                                </span>
                                                <span *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                                                    Yearly
                                                </span>
                                                <span *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'">
                                                   {{checkoutService.getSignaturePlanText(planForm)}}
                                                </span>
                                            </div>
                                            
                                            <div class="front_value">
                                                <span class="img">
                                                    <img [src]="item?.plan_optional_item_category?.bannerImage" [alt]="item?.plan_optional_item_category?.title" width="121" height="121">
                                                </span>
                                                <h3>
                                                    {{item?.plan_optional_item_category?.title}}
                                                </h3>
                                                <b class="clickTxt" (click)="toggleShowFrontPanel(item.planPriceId)">View what’s covered</b>
                                                
                                                <div class="original_value">
                                                    <div class="plan_tXt month" *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                                                        <span>$<b>{{(item?.discountedMonthlyPrice) | currency:'':''}}</b></span>
                                                    </div>
                                                    <div class="plan_tXt annual" *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                                                        <span>$<b>{{( item?.discountedYearlyPrice) | currency:'':''}}</b></span>
                                                    </div>
                                                    
                                                    <div class="plan_tXt three_annual" *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'">
                                                        <span>$<b>{{checkoutService.getSignaturediscountedPrice(item, planForm) | currency:'':''}}</b></span>
                                                    </div>
                                                    
                                                </div>
                                                <del *ngIf="planForm.value?.planType === 'PAY MONTHLY'">
                                                {{item?.displayMonthlyPrice | currency}}
                                                </del>
                                                <del *ngIf="planForm.value?.planType === 'PAY ANNUALLY'">
                                                    {{item?.displayYearlyPrice | currency}}
                                                </del>
                                                <del *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'">
                                                  {{checkoutService.getSignatureDisplayPrice(item, planForm) | currency}}
                                                </del>
                                                <small *ngIf="planForm.value?.planType === 'PAY MONTHLY'"> Billed monthly</small>
                                                <small *ngIf="planForm.value?.planType === 'PAY ANNUALLY'"> Billed annually</small>
                                                <small *ngIf="planForm.value?.planType === 'PAY FOR 3 YEARS'"> Billed {{checkoutService.getSignaturePlanText(planForm)}}</small>
                                            </div>

                                            <div class="badge-container"  *ngIf="planForm.value?.freeMonth > 0">
                                                <!-- Radiating circles -->
                                                <div class="radiating-circle circle1"></div>
                                                <div class="radiating-circle circle2"></div>
                                                <div class="radiating-circle circle3"></div>
                                                
                                                <!-- Main badge -->
                                                <div class="badge">
                                                    <div class="shine"></div>
                                                    <div class="badge-content">
                                                        <div class="number">{{planForm.value?.freeMonth}}</div>
                                                        <div class="months"  *ngIf="planForm.value?.freeMonth > 1">months</div>
                                                         <div class="months" *ngIf="planForm.value?.freeMonth === 1" >month</div>
                                                        <div class="free">FREE</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="check_back" *ngIf="!item.showFrontPanel">
                                            <div class="topbackprt">
                                                <span>
                                                <h5>{{item?.plan_optional_item_category?.title}}</h5>
                                                
                                                </span>
                                                <!-- <div class="backimg">
                                                <img loading="lazy" [ngSrc]="item?.plan_optional_item_category?.bannerImage" [alt]="item?.plan_optional_item_category?.title" width="110" height="110">
                                                </div> -->
                                                <b class="clickTxt" (click)="toggleShowFrontPanel(item.planPriceId)">
                                                    View Pricing
                                                </b>
                                            </div>
                                            <div class="box__2"> 
                                                <ul>
                                                    <li *ngFor="let coverItm of item?.coveredItems">
                                                        <span>{{coverItm?.coveredItems?.title}}</span>   <b>{{coverItm?.quantity}}</b>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                        </div>
                                        <div class="popularprt" *ngIf="item?.plan_optional_item_category?.title === 'ELITE COMPLETE'">
                                            BEST VALUE
                                        </div>
                                    </div>
                                </div>
                                <div style="text-align: center; padding:10px 0;">
                                    <mat-error *ngIf="planForm.controls['planPriceId'].touched && planForm.controls['planPriceId'].hasError('required')">This is required</mat-error>
                                </div>
                                <div class="no_plan" *ngIf="planPrice?.length === 0">
                                    <mat-error >No plan available for the selected property type and property size.</mat-error>
                                </div>
                                <div class="twobtnarea">
                                    <button class="continue" (click)="checkPlanFrom()" *ngIf="!loading && planPrice.length && (isRenewAgreement ? true : this.planForm.value.planPriceId !== oldPlanPriceId)" [disabled]="planPrice.length === 0" >
                                        Continue <mat-icon>arrow_forward</mat-icon>
                                    </button>
                                    <img [ngSrc]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="loading" />
                                </div>
                            </div>

                            <div class="webnone">
                                <div class="copayprt">
                                    <span>
                                        <mat-icon>room</mat-icon>
                                        Your address
                                    </span>
                                    <p>
                                        {{addressInfo.address}} {{addressInfo.unitNumber ? (',' + addressInfo.unitNumber) : ''}}
                                    </p>
                                    <small (click)="openChangeAddressModal(addressInfo)" class="edit">
                                        Change address
                                    </small>
                                </div>
                                <div class="copayprt">
                                    <span>
                                        Property Size
                                    </span>
                                    <p>
                                        {{PropertyTypeSizeForm.value.propertySize}}  
                                    </p>
                                    <span>
                                        Property Type
                                    </span>
                                    <p>
                                        {{PropertyTypeSizeForm.value.propertyType}}
                                    </p>
                                    <small (click)="openChangePropertyModal()" class="edit">
                                        <mat-icon>edit</mat-icon> Edit
                                    </small>
                                </div>
                            </div>
                        </div>
                        
                        
                    </div>

                    
                </form>
                </div> 

                <!-- STEP 2 -->
                <div class="step step2" *ngIf="steps === 2">
                    <form [formGroup]="coverItemsForm">
                        <div class="optionalwrap">
                            <div class="leftoptionalprt">
                                <div class="optional_covagearea">
                                    <button class="skip" (click)="handleSkip()" *ngIf="selectedOptionalCoverItems?.length === 0">
                                        Skip
                                    </button>
                                    <h3>
                                        Optional coverage
                                    </h3>
                                    <p>
                                        There's is no such thing as one-fix-fits-all. That's why we offer more ways to supplement your coverage.
                                    </p>
                                    <ul>
                                        <ng-container  *ngFor="let item of optionalCoverItems;  let i = index">
                                            <li [ngClass]="{'optional_item_selection': item?.quantity > 0}">
                                            <span>
                                                {{item?.title}} 
                                                <!-- <sup (click)="commonService.openPlanCoveredItemDialog(item, true)"><mat-icon>info</mat-icon></sup> -->
                                            </span>
                                            
                                            
                                            <p *ngIf="item?.description">
                                            {{item.description}}
                                            </p>
                                            <b>{{calculateOptionalItemValue(item?.standardPrice, false, true)| currency}}{{selectedPeriodInitial}}</b>
        
                                            <div class="pricesec">
                                                <ng-container>
                                                {{calculateOptionalItemValue(item?.standardPrice, false, true) | currency}}
                                                </ng-container>
                                                <div class="added_sec">
                                                    <button class="optional_quantity" *ngIf="item?.quantity > 0" (click)="removeQuantity(item, i)"><mat-icon>remove_circle</mat-icon></button>
                                                    <span *ngIf="item?.quantity > 0">{{item?.quantity}}</span>
                                                    <button class="optional_quantity" *ngIf="item?.quantity > 0" [ngClass]="{'disabled-add-items': !item?.allowedMultipleItem && item?.quantity === 1 }" [disabled]="!item?.allowedMultipleItem && item?.quantity === 1" (click)="addQuantity(item, i)"><mat-icon>add_circle</mat-icon></button>
                                                    <button class="add_btn" *ngIf="item?.quantity === 0" (click)="onCheckboxChange(item,i)"><mat-icon>add</mat-icon> <span>ADD</span></button>
                                                </div>
                                            </div>
                                            <div class="border"></div>
                                        </li>
                                    </ng-container>
                                    </ul>
                                </div>
                            </div>
                            <div class="right_optioanalprt">
                                <div class="inner_rightcont">
                                    <div class="topcartprt">
                                        <h3>
                                            Optionl Items Summary
                                        </h3>
                                    </div>
                                    <app-common-summary-section
                                    [isCoverageInfo]="isCoverageInfo"
                                    [updateCoverageDetails]="updateCoverageDetails"
                                    [selectedPlanPrice]="selectedPlanPrice"
                                    [planForm]="planForm"
                                    [selectedOptionalCoverItems]="selectedOptionalCoverItems"
                                    [selectedOptionalItemsPlanWise]="selectedOptionalItemsPlanWise"
                                    [selectedPeriodInitial]="selectedPeriodInitial"
                                    [calculateOptionalItemValue]="calculateOptionalItemValue"
                                    [totalCostPrice]="totalCostPrice"
                                    [processingFee]="processingFee"
                                    [salesTax]="salesTax"
                                    [subTotalPrice]="subTotalPrice"
                                    [effectiveTermDate]="effectiveTermDate"
                                    [paymentMethod]="paymentMethod"
                                    [totalSavings]="totalSavings"
                                    [coPayFee]="coPayFee"
                                    [optionalPanelOpenState]="optionalPanelOpenState"
                                    [subTotalWithDiscounts]="subTotalWithDiscounts"
                                    [fieldConfiguration]="{monthlyPayment: false,
                                    effectiveTerm: false,
                                    totalCharged: false,
                                    youSaved: false,
                                    stepNumber: 2}"
                                    [installmentForm]="installmentForm"
                                    [additionalDiscount]="additionalDiscount"
                                    [waitingPeriodForm]="waitingPeriodForm"
                                    [customPriceForm]="customPriceForm"
                                    [isSuperAdmin]="isSuperAdmin"
                                    [installmentLimits]="checkoutService.findInstallmentLimits(planForm, installmentLimits)"
                                    ></app-common-summary-section>
                                    
                                    <div class="twobtnarea">
                                        <button class="back" (click)="handleEditCoverage()">
                                            <mat-icon>arrow_back</mat-icon> Back 
                                        </button>
                                        <button class="continue" (click)="steps = 3; scrolltoposition();">
                                            Continue <mat-icon>arrow_forward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </form>
                
                </div> 

                <!-- STEP 3 -->
               <div class="step step8" [style.display]="steps == 3 ? 'block' : 'none'">
                    <h4>
                        Finalize Your Coverage
                    </h4>

                    <div class="delivery_box">
                        <div class="leftaddressprt">
                            <form [formGroup]="customerInfoForm">
                            <div class="contact_info">
                                <div class="address_sec">
                                    <div class="addsec">
                                        <mat-icon>home</mat-icon>
                                        <span>
                                            <h4>
                                                Covered address
                                            </h4>
                                            <p>
                                               {{formatAddress(addressInfo)}}
                                            </p>
                                        </span>
                                    </div>
                                  
                                    <small class="change_add" (click)="openChangeAddressModal(addressInfo)" class="edit">
                                        <button><mat-icon >edit</mat-icon></button>  Change
                                    </small>
                                </div>
                                <div class="info_heading">
                                    <h3>
                                        Agreement Holder Information
                                    </h3>
                                    <button *ngIf="disableHolderInfoField" (click)="handleHolderInfoEdit()">
                                        <mat-icon >edit</mat-icon>
                                        
                                    </button>

                                    <button *ngIf="!disableHolderInfoField" (click)="handleHolderInfoEdit()" >
                                        <mat-icon >check</mat-icon>
                                        
                                    </button>
                                   
                                </div>
                               
                                <div class="fullinputfield">
                                    <div class="inputfield">
                                        <input type="text" [attr.disabled]="isHolderInfoDisabled" placeholder="First Name" formControlName="firstName" (keyup)="apiService.restrictSpace($event)" (keypress)="apiService.restrictSpecialChar($event)"/>
                                        <mat-error *ngIf="customerInfoForm.controls['firstName'].touched && customerInfoForm.controls['firstName'].hasError('required')">
                                            This is required
                                        </mat-error>
                                        <mat-error *ngIf="customerInfoForm.controls['firstName'].touched && customerInfoForm.controls['firstName'].hasError('minlength')">
                                            Please enter a valid first name.
                                        </mat-error>
                                     </div>
                                     <div class="inputfield">
                                        <input type="text" [attr.disabled]="isHolderInfoDisabled" placeholder="Last Name" formControlName="lastName" (keyup)="apiService.restrictSpace($event)" (keypress)="apiService.restrictSpecialChar($event)"/>
                                        <mat-error *ngIf="customerInfoForm.controls['lastName'].touched && customerInfoForm.controls['lastName'].hasError('required')">
                                            This is required.
                                        </mat-error>
                                        <mat-error *ngIf="customerInfoForm.controls['lastName'].touched && customerInfoForm.controls['lastName'].hasError('minlength')">
                                            Please enter a valid last name.
                                        </mat-error>
                                     </div>
                                </div>
                                <div class="fullinputfield">
                                    <div class="inputfield">
                                        <input type="text" [attr.disabled]="isHolderInfoDisabled" placeholder="Email address" formControlName="email"/>
                                        <mat-error *ngIf="customerInfoForm.controls['email'].touched && customerInfoForm.controls['email'].hasError('required')">
                                            This is required.
                                        </mat-error>
                                        <mat-error *ngIf="customerInfoForm.controls['email'].touched && customerInfoForm.controls['email'].hasError('pattern')">
                                            Email no is not valid.
                                        </mat-error>
                                     </div>
                                     <div class="inputfield">
                                        <input type="text" [attr.disabled]="isHolderInfoDisabled" placeholder="Phone number" formControlName="phone" mask="(000) 000-0000"/>
                                        <mat-error *ngIf="customerInfoForm.controls['phone'].touched && customerInfoForm.controls['phone'].hasError('required')">
                                            This is required.
                                        </mat-error>
                                        <mat-error *ngIf="customerInfoForm.controls['phone'].touched && customerInfoForm.controls['phone'].hasError('pattern')">
                                            Phone no is not valid.
                                        </mat-error>
                                     </div>
                                </div>
                            </div>
                            </form>
                            <div class="payment_info" *ngIf="!isZeroAmount">
                                <h3>
                                    Payment
                                </h3>

                                <div class="payment_prt">
                                    <div class="payment_option">
                                        <span class="tab"  *ngIf="!hideCard" [ngClass]="{'active': paymentMethod  === PaymentMethods.card}" (click)="togglePayment(PaymentMethods.card)">
                                            <mat-icon>payment</mat-icon> Credit/Debit Card
                                        </span>
                                        <span class="tab"  *ngIf="!refundToDefaultCard" [ngClass]="{'active': paymentMethod  === PaymentMethods.bank}" (click)="togglePayment(PaymentMethods.bank)">
                                            <mat-icon>account_balance</mat-icon> Bank Account
                                        </span>
                                        <span class="tab"  *ngIf="!refundToDefaultCard && updateCoverageDetails?.refundAmount>0" [ngClass]="{'active': paymentMethod  === PaymentMethods.check}" (click)="togglePayment(PaymentMethods.check)">
                                            <mat-icon>account_balance</mat-icon> Check
                                        </span>

                                        <span class="tab"  *ngIf="planForm.value?.planType !== 'PAY MONTHLY' && !isCoverageInfo" [ngClass]="{'active': paymentMethod  === PaymentMethods.escrow}" (click)="togglePayment(PaymentMethods.escrow)">
                                            <mat-icon> local_atm</mat-icon> Escrow Invoice
                                        </span>
                                    </div>

                                    <div class="box_inputarea">
                                        <div class="credit_inputarea" *ngIf="paymentMethod  === PaymentMethods.card && !hideCard ">
                                        <app-common-card-details-form [commonForm]="cardDetailsForm" (getCardTypeHandler)="getCardType($event)" [showTransactionNumber]="showTransactionNumber"></app-common-card-details-form>

                                        </div>
                                        <div class="credit_inputarea" *ngIf="paymentMethod  === PaymentMethods.bank && !refundToDefaultCard" >
                                            <form [formGroup]="bankDetailsForm">
                                            <div class="threepanel">
                                                <span class="halfwidth">
                                                    <label>Routing Number</label>
                                                    <input type="text"  placeholder="Routing Number" formControlName="routingNumber"  mask="000000000" required (change)="getBankDetail()">
                                                    <mat-error *ngIf="bankDetailsForm.controls['routingNumber'].touched && bankDetailsForm.controls['routingNumber'].hasError('required')">
                                                        This is required
                                                    </mat-error>
                                                    <mat-error
                                                      *ngIf="bankDetailsForm.controls['routingNumber'].touched && (bankDetailsForm.controls['routingNumber'].hasError('minlength')|| bankDetailsForm.controls['routingNumber'].hasError('maxlength'))">
                                                      Routing Number must be 9 digits.
                                                    </mat-error>
                                                </span>

                                                <span class="halfwidth">
                                                    <label>Bank Name</label>
                                                    <input type="text" placeholder=""  formControlName="bankName" disabled/>
                                                </span>
                                                <!-- <span class="halfwidth">
                                                    <label>Account Type</label>
                                                    <mat-select formControlName="accountType" required >
                                                        <mat-option value="checking">Personal Checking</mat-option>
                                                        <mat-option value="checking">Business Checking </mat-option>
                                                      </mat-select>
                                                      <mat-error *ngIf="bankDetailsForm.controls['accountType'].touched && bankDetailsForm.controls['accountType'].hasError('required')">
                                                        This is required
                                                    </mat-error>   
                                                </span> -->
                                            
                                                <span class="halfwidth">
                                                    
                                                    <input type="text" placeholder="Name on the Account"  formControlName="nameOnAccount" required />
                                                    <mat-error *ngIf="bankDetailsForm.controls['nameOnAccount'].touched && bankDetailsForm.controls['nameOnAccount'].hasError('required')">
                                                        This is required
                                                    </mat-error>   
                                                </span>
                                                <span class="halfwidth">
                                                  
                                                    <input  type="text" placeholder="Account Number" mask="0000*"  minlength="4" formControlName="accountNumber" required />
                                                    <mat-error *ngIf="bankDetailsForm.controls['accountNumber'].touched && bankDetailsForm.controls['accountNumber'].hasError('required')">
                                                        This is required
                                                    </mat-error>
                                                    <mat-error
                                                    *ngIf="bankDetailsForm.controls['accountNumber'].touched && bankDetailsForm.controls['accountNumber'].hasError('minlength')" >
                                                    Account Number must be minimum 4 digits.
                                                  </mat-error>
                                                </span>

                                                <span class="halfwidth" *ngIf="showBankTransactionNumber">
                                                    <input  type="text"  placeholder="Transaction Number" formControlName="transactionNumber" />
                                                    <mat-error *ngIf="bankDetailsForm.controls['transactionNumber'].touched && bankDetailsForm.controls['transactionNumber'].hasError('required')">
                                                        This is required
                                                    </mat-error>

                                                </span>
                                        
                                               
                                            </div>
                                        </form>
                                            </div>

                                            <div class="credit_inputarea" *ngIf="paymentMethod  === PaymentMethods.check && isCoverageInfo && updateCoverageDetails?.refundAmount>0 " >
                                                <form [formGroup]="checkForm">
                                                <div class="threepanel">
                                                    <span class="halfwidth">
                                                        <label>Check Number</label>
                                                        <input
                                                        type="text"
                                                        placeholder="**** **** **** ****"
                                                        formControlName="checkNumber"
                                                        mask="0000*"
                                                      />
                                                        <mat-error
                                                        *ngIf="
                                                          checkForm.controls['checkNumber'].touched &&
                                                          checkForm.controls['checkNumber'].hasError(
                                                            'required'
                                                          )
                                                        "
                                                      >
                                                        This is required
                                                      </mat-error>
                                                      <mat-error
                                                        *ngIf="
                                                          checkForm.controls['checkNumber'].touched &&
                                                          checkForm.controls['checkNumber'].hasError(
                                                            'minlength'
                                                          )
                                                        "
                                                      >
                                                        Check Number must be minimum 4 digits.
                                                      </mat-error>
                                                    </span>
                                                </div>
                                            </form>
                                                </div>


                                        <div class="credit_inputarea" [style.display]="paymentMethod  === PaymentMethods.escrow && !isCoverageInfo ? 'block' : 'none'">
                                        <form [formGroup]="escrowDetailsForm">
                                            <div class="threepanel">
                                                
                                                <span class="halfwidth">
                                                    <label>Amount Paying Today</label>
                                                    <input type="text" placeholder="$0" formControlName="closingAmount" min="0"  mask="separator.2" thousandSeparator="," (change)="handleClosingAmountChange()" prefix="$" />
                                                    <mat-error
                                                      *ngIf="escrowDetailsForm.controls['closingAmount'].touched && escrowDetailsForm.controls['closingAmount'].hasError('max')">
                                                      Enter a closing amount less than {{customPriceForm.get('isCustomPrice')?.value ? ((customPriceForm.get('customPrice')?.value || 0) | currency) : (subTotalWithDiscounts | currency)}}.
                                                    </mat-error>
                                                    <mat-error
                                                    *ngIf="escrowDetailsForm.controls['closingAmount'].touched && escrowDetailsForm.controls['closingAmount'].hasError('min')">
                                                    Enter a closing amount greater than 0.
                                                  </mat-error>
                                                </span>
                                                <span class="halfwidth">
                                                    <label>Amount Paying Through Closing</label>
                                                    <input type="text" placeholder="Payment at Closing"  mask="separator.2" thousandSeparator="," prefix="$" [value]="'$'+ formatPriceInNumber(escrowTotalCharged <= 0 ? customPriceForm.get('isCustomPrice')?.value ? (customPriceForm.get('customPrice')?.value || 0) : subTotalWithDiscounts : escrowTotalCharged, true).toFixed(2)" [attr.disabled]="true" />
                                                </span>
                                                <div class="datepanle">
                                                    <span class="datapick">
                                                        <mat-form-field class="example-full-width">
                                                            <!-- <mat-label>Closing Date</mat-label> -->
                                                            <input matInput formControlName="closingDate" [matDatepicker]="picker" [min]="minDate" (click)="picker.open()" [readonly]="true">
                                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker></mat-datepicker>
                                                        </mat-form-field>
                                                        <mat-error
                                                        *ngIf="escrowDetailsForm.controls['closingDate'].touched && escrowDetailsForm.controls['closingDate'].hasError('required')">
                                                        This is required.
                                                        </mat-error>
                                                    </span>
                                                
                                                    <span>
                                                        <input type="text" placeholder="Realtor Name" formControlName="realtorName" (keyup)="apiService.restrictSpace($event)" (keypress)="apiService.restrictSpecialChar($event)"/>
                                                        <mat-error
                                                        *ngIf="escrowDetailsForm.controls['realtorName'].touched && escrowDetailsForm.controls['realtorName'].hasError('minlength')">
                                                        Enter valid realtor name.
                                                        </mat-error>
                                                    </span>

                                                    <span>
                                                        <input type="email" placeholder="Realtor Email Address" formControlName="realtorEmail" (keyup)="changeEscrowEmailAndSet('realtorEmail')"/>
                                                        <mat-error
                                                        *ngIf="escrowDetailsForm.controls['realtorEmail'].touched && escrowDetailsForm.controls['realtorEmail'].hasError('pattern')">
                                                        Enter valid realtor email.
                                                    </mat-error>
                                                    </span>
                                                </div>
                                                <span>
                                                    <input type="email" placeholder="Title Company Name" formControlName="companyName" (keypress)="apiService.allowAlphabate($event)"/>
                                                <mat-error
                                                  *ngIf="escrowDetailsForm.controls['companyName'].touched && escrowDetailsForm.controls['companyName'].hasError('minlength')">
                                                  Enter valid company name.
                                                </mat-error>
                                                </span>
                                                <span>
                                                    <input type="email" placeholder="Title Company Email Address" formControlName="companyEmail" (keyup)="changeEscrowEmailAndSet('companyEmail')"/>
                                                <mat-error
                                                *ngIf="escrowDetailsForm.controls['companyEmail'].touched && escrowDetailsForm.controls['companyEmail'].hasError('pattern')">
                                                Enter valid company email.
                                              </mat-error>
                                                </span>
                                                
                                            </div>
                                        </form>
                                        <div [style.display]="showEscrowCard ? 'block' : 'none'" class="showcardInput">
                                            <h3>Payment Details</h3>
                                            <app-common-card-details-form  [commonForm]="escrowDetailsForm" (getCardTypeHandler)="getCardType($event)" [showTransactionNumber]="showTransactionNumber"></app-common-card-details-form>
                                            <form [formGroup]="billingInfoForm">
                                                <div class="same_address">
                                                    <h3>
                                                        Billing Address
                                                    </h3>
                                                    <input type="checkbox" [checked]="isMatchBillingAddress" (change)="checkSameBillingAddress($event)"/>
                                                    Same as covered address
                                                </div>
                                                <div class="fullinputfield">
                
                                                    <div class="billing_addressprt">
                                                        <div class="inputfield onethird"  [ngClass]="{'fullWidth': isMatchBillingAddress}">
                                                            <input type="text" placeholder="Address" formControlName = "address"  [attr.disabled]="isMatchBillingAddress ? true : null " (keyup)="apiService.changeInput(address, true)" #addressEscrow/>
                                                            <mat-error
                                                            *ngIf="billingInfoForm.controls['address'].touched && billingInfoForm.controls['address'].hasError('required')">
                                                            This is required
                                                         </mat-error>
                                                        <mat-error *ngIf="billingInfoForm.controls['address'].hasError('notValid')">
                                                            Please select cover state from the list of suggested addresses.
                                                        </mat-error>
                                                        </div>
                                                        <div class="inputfield onehalf" *ngIf="!isMatchBillingAddress">
                                                            <input type="text" [placeholder]="!isMatchBillingAddress ? 'Unit Number' : ''" formControlName = "unitNumber"  [attr.disabled]="isMatchBillingAddress ? true : null"/>
                                                         </div>
                                                    </div>
                                                   
                                                     
                                                     <div class="threepanel" *ngIf="!isMatchBillingAddress">
                                                        <span>
                                                            <input type="text" placeholder="City" formControlName="city" [attr.disabled]="isMatchBillingAddress ? true : null "/>
                                                            <mat-error
                                                            *ngIf="billingInfoForm.controls['city'].touched && billingInfoForm.controls['city'].hasError('required')">
                                                            This is required.
                                                          </mat-error>
                                                        </span>
                                                        <span>
                                                            <input type="text" placeholder="State" formControlName="state" [attr.disabled]="isMatchBillingAddress ? true : null "/>
                                                            <mat-error
                                                            *ngIf="billingInfoForm.controls['state'].touched && billingInfoForm.controls['state'].hasError('required')">
                                                            This is required.
                                                          </mat-error>
                                                        </span>
                                                        <span>
                                                            <input type="text" placeholder="Zip" formControlName="zip" mask="00000" [attr.disabled]="isMatchBillingAddress ? true : null " (keyup)="checkZipCode()"/>
                                                            <mat-error
                                                            *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('required')">
                                                            This is required.
                                                          </mat-error>
                                                          <mat-error
                                                            *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('mask')">
                                                            Enter valid zip.
                                                          </mat-error>
                                                          <mat-error
                                                          *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('notValid')">
                                                          This zip code is not valid.
                                                        </mat-error>
                                                        </span>
                                                     </div>
                                                </div>
                                            </form>
                                        </div>
                                       
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="samecoverad" [style.display]="paymentMethod  !== PaymentMethods.escrow ? 'block' : 'none'">
                            <form [formGroup]="billingInfoForm">
                                <div class="same_address">
                                    <h3>
                                        Billing Address
                                    </h3>
                                    <input type="checkbox" [checked]="isMatchBillingAddress" (change)="checkSameBillingAddress($event)"/>
                                    Same as covered address
                                </div>
                                <div class="fullinputfield">

                                    <div class="billing_addressprt">
                                        <div class="inputfield onethird"  [ngClass]="{'fullWidth': isMatchBillingAddress}">
                                            <input type="text" placeholder="Address" formControlName = "address"  [attr.disabled]="isMatchBillingAddress ? true : null " (keyup)="apiService.changeInput(address, true)" #address/>
                                            <mat-error
                                            *ngIf="billingInfoForm.controls['address'].touched && billingInfoForm.controls['address'].hasError('required')">
                                            This is required
                                         </mat-error>
                                        <mat-error *ngIf="billingInfoForm.controls['address'].hasError('notValid')">
                                            Please select cover state from the list of suggested addresses.
                                        </mat-error>
                                        </div>
                                        <div class="inputfield onehalf" *ngIf="!isMatchBillingAddress">
                                            <input type="text" [placeholder]="!isMatchBillingAddress ? 'Unit Number' : ''" formControlName = "unitNumber"  [attr.disabled]="isMatchBillingAddress ? true : null"/>
                                         </div>
                                    </div>
                                   
                                     
                                     <div class="threepanel" *ngIf="!isMatchBillingAddress">
                                        <span>
                                            <input type="text" placeholder="City" formControlName="city" [attr.disabled]="isMatchBillingAddress ? true : null "/>
                                            <mat-error
                                            *ngIf="billingInfoForm.controls['city'].touched && billingInfoForm.controls['city'].hasError('required')">
                                            This is required.
                                          </mat-error>
                                        </span>
                                        <span>
                                            <input type="text" placeholder="State" formControlName="state" [attr.disabled]="isMatchBillingAddress ? true : null "/>
                                            <mat-error
                                            *ngIf="billingInfoForm.controls['state'].touched && billingInfoForm.controls['state'].hasError('required')">
                                            This is required.
                                          </mat-error>
                                        </span>
                                        <span>
                                            <input type="text" placeholder="Zip" formControlName="zip" mask="00000" [attr.disabled]="isMatchBillingAddress ? true : null " (keyup)="checkZipCode()"/>
                                            <mat-error
                                            *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('required')">
                                            This is required.
                                          </mat-error>
                                          <mat-error
                                            *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('mask')">
                                            Enter valid zip.
                                          </mat-error>
                                          <mat-error
                                          *ngIf="billingInfoForm.controls['zip'].touched && billingInfoForm.controls['zip'].hasError('notValid')">
                                          This zip code is not valid.
                                        </mat-error>
                                        </span>
                                     </div>
                                </div>
                            </form>
                            </div>
                            
                         
                        </div>

                        <div class="rightsideaddarea">
                           
                            <div class="topcartprt">
                                <h3>
                                    Coverage Summary
                                </h3>
                                <a (click)="handleEditCoverage()">
                                    Edit Coverage
                                </a>
                            </div>
                            <div class="add_dis" *ngIf="!isSuperAdmin">
                                    <label>Additional Discount</label>
                                    <div class="info_heading rightinfo_heading">

                                            <div class="info_input">
                                                <input type="text" placeholder="$0" [attr.disabled]="isAdditionalDiscountDisabled" [(ngModel)]="additionalDiscountField" min="0" [max]="subTotalPrice"  mask="separator.2" thousandSeparator="," prefix="$" />
                                
                                                <button *ngIf="disableAdditionalDiscountField" (click)="handleAdditionDiscountChange('edit')">
                                                    <mat-icon >edit</mat-icon>
                                                    
                                                </button>
    
                                                <button *ngIf="!disableAdditionalDiscountField" (click)="handleAdditionDiscountChange('save')" >
                                                    <mat-icon >check</mat-icon>
                                                    
                                                </button>
                                            </div>
                                           

                                            <mat-error
                                            *ngIf="isExcedingMaximumDiscount">
                                            Enter a discount less than or equals to {{maximumAdditionalDiscount|currency}}.
                                            </mat-error>
                                    </div>
                            </div>
                            
                          <app-common-summary-section
                          [isCoverageInfo]="isCoverageInfo"
                          [updateCoverageDetails]="updateCoverageDetails"
                          [selectedPlanPrice]="selectedPlanPrice"
                          [planForm]="planForm"
                          [selectedOptionalCoverItems]="selectedOptionalCoverItems"
                          [selectedOptionalItemsPlanWise]="selectedOptionalItemsPlanWise"
                          [selectedPeriodInitial]="selectedPeriodInitial"
                          [calculateOptionalItemValue]="calculateOptionalItemValue"
                          [totalCostPrice]="totalCostPrice"
                          [processingFee]="processingFee"
                          [salesTax]="salesTax"
                          [subTotalPrice]="subTotalPrice"
                          [effectiveTermDate]="effectiveTermDate"
                          [paymentMethod]="paymentMethod"
                          [totalSavings]="totalSavings"
                          [coPayFee]="coPayFee"
                          [loading]="loading"
                          [showEscrowCard]="showEscrowCard"
                          [escrowTotalCharged]="escrowTotalCharged"
                          [escrowDetailsForm]="escrowDetailsForm"
                          [subTotalWithDiscounts]="subTotalWithDiscounts"
                          [fieldConfiguration]="{monthlyPayment: true,
                            effectiveTerm: true,
                            totalCharged: true,
                            youSaved: true,
                            stepNumber: 3}"
                          [installmentForm]="installmentForm"
                          [additionalDiscount]="additionalDiscount"
                          [waitingPeriodForm]="waitingPeriodForm"
                          [installmentLimits]="checkoutService.findInstallmentLimits(planForm, installmentLimits)"
                            (getPaymentType)="handleGetPaymentType($event)"
                            (handleRemoveOptionalItems)="handleDeleteOptionalItems($event)"
                            (isInitialPaymentFieldDisabled)="handleInitialPaymentFieldDisabled($event)"
                          [customPriceForm]="customPriceForm"
                           [isSuperAdmin]="isSuperAdmin"
                          ></app-common-summary-section>
                            
                          
    <div class="btnprt">
        <button (click)="checkCardForm()" *ngIf="!loading && orderButton && !isExcedingMaximumDiscount && disableHolderInfoField && disableAdditionalDiscountField && disabledInitialPaymentField" >
        {{isCoverageInfo ? (isRenewAgreement ? 'RENEW AGREEMENT' : 'UPDATE COVERAGE') : 'PLACE ORDER' }}   
        </button>
        <img [ngSrc]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="loading" />
    </div>

    <small style="margin-top: 20px; display: block; text-align: center; padding: 0 20px;">
        <b>Payment terms:</b> By purchasing coverage, you agree to our service agreement, privacy policy, and terms of service, commit to making payments in accordance with the specified terms using the provided payment information, and consent to being contacted by us regarding the purchase.
    </small>
                        </div>
                    </div>
                </div>  


            <!-- STEP 4 -->

           <div class="step step9" *ngIf="steps === 4">
                <div class="order_cofirmbody">
                    <div class="left_confirm">
                        <h4>Thank You for trusting Elite!</h4>
                        <div class="effectiveprt">
                            <span>
                                <b>Agreement number:</b> {{agreementNumber}}
                            </span>
                            <span>
                                <b>Effective Term:</b> {{effectiveTermDate}}
                            </span>
                        </div>
                        <div class="info_prt">
                            <h3>
                                Your information
                            </h3>
                            <span>
                                <label>
                                    Name:
                                </label>
                                {{customerInfoForm.value.firstName}} {{customerInfoForm.value.lastName}}
                            </span>
                            <span>
                                <label>
                                    Email:
                                </label>
                                {{customerInfoForm.value.email}}
                            </span>
                            <span>
                                <label>
                                    Phone:
                                </label>
                                {{customerInfoForm.value.phone | mask : '(000) 000-0000'}}
                            </span>
                        </div>
                        <div class="addrees_prt">
                            <div class="addr">
                                <h3>
                                    Property Address
                                </h3>
                                <p>
                                    {{formatAddress(addressInfo)}}
                                </p>
                            </div>
                            <div class="addr" *ngIf="(paymentMethod  === (PaymentMethods.card||PaymentMethods.bank)) || (paymentMethod  === PaymentMethods.escrow && showEscrowCard)">
                                <h3>
                                    Billing Address
                                </h3>
                                <p>
                                    {{formatAddress(billingInfoForm.value)}}
                                </p>
                            </div>
                        </div>
                        <div class="downloadPart">
                            <button (click)="getServiceAgreementPdf()">Download Agreement</button>
                        </div>
                    </div>

                    <div class="right_summeryprt">
                        <div class="top_shape"></div>
                        <div class="top_orderprt">
                            <h3>
                                Order Summary
                            </h3>
                            <div class="listing">
                                <ul>
                                    <li>
                                        <label>Purchase Date:</label>
                                        <b>{{date}}</b>
                                    </li>
                                    <li>
                                        <label>Plan Term:</label>
                                        <b *ngIf="planForm.value.planType === 'PAY MONTHLY'">Monthly Recurring</b>
                                        <b *ngIf="planForm.value.planType === 'PAY ANNUALLY'">Yearly</b>
                                        <b *ngIf="planForm.value.planType === 'PAY FOR 3 YEARS'">{{getPlanType()}} Signature Program</b>
                                    </li>
                                    <li *ngIf="paymentMethod  === PaymentMethods.card && !isZeroAmount">
                                        <label *ngIf="updateCoverageDetails?.refundAmount>0">Refunded to </label>   <label>Card Number:</label>
                                        {{formattedCardNumber(cardDetailsForm.value.cardNumber)}}
                                    </li>
                                    <li *ngIf="paymentMethod  === PaymentMethods.bank && !isZeroAmount">
                                        <label *ngIf="updateCoverageDetails?.refundAmount>0">Refunded to </label>   <label>Account Number:</label>
                                        {{bankDetailsForm.value.accountNumber}}
                                    </li>
                                    <li *ngIf="paymentMethod  === PaymentMethods.check && !isZeroAmount">
                                        <label *ngIf="updateCoverageDetails?.refundAmount>0">Refunded using </label>  <label>Check Number:</label>
                                        {{checkForm?.value?.checkNumber}}
                                    </li>

                                    <li *ngIf="isZeroAmount">
                                         <label>No Additional Amount has been charged.</label>
                                        
                                    </li>

                                    <li *ngIf="paymentMethod  === PaymentMethods.escrow && showEscrowCard && !isZeroAmount">
                                        <label>Card Number:</label>
                                        {{formattedCardNumber(escrowDetailsForm.value.cardNumber)}}
                                    </li>
                                    <li *ngIf="planForm.value.planType === 'PAY MONTHLY'">
                                        <label>Upcoming Payments:</label>
                                        {{ planForm.value?.monthlyPaymentDate }} of each month
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <app-common-summary-section
                        [isCoverageInfo]="isCoverageInfo"
                        [updateCoverageDetails]="updateCoverageDetails"
                        [selectedPlanPrice]="selectedPlanPrice"
                        [planForm]="planForm"
                        [selectedOptionalCoverItems]="selectedOptionalCoverItems"
                        [selectedOptionalItemsPlanWise]="selectedOptionalItemsPlanWise"
                        [selectedPeriodInitial]="selectedPeriodInitial"
                        [calculateOptionalItemValue]="calculateOptionalItemValue"
                        [totalCostPrice]="totalCostPrice"
                        [processingFee]="processingFee"
                        [salesTax]="salesTax"
                        [subTotalPrice]="subTotalPrice"
                        [effectiveTermDate]="effectiveTermDate"
                        [paymentMethod]="paymentMethod"
                        [totalSavings]="totalSavings"
                        [coPayFee]="coPayFee"
                        [isFromBilling]="true"
                        [subTotalWithDiscounts]="subTotalWithDiscounts"
                        [fieldConfiguration]="{monthlyPayment: false,
                          effectiveTerm: false,
                          totalCharged: false,
                          youSaved: true,
                          stepNumber: 4}"
                        [additionalDiscount]="additionalDiscount"
                        [waitingPeriodForm]="waitingPeriodForm"
                        [installmentLimits]="checkoutService.findInstallmentLimits(planForm, installmentLimits)"
                        [customPriceForm]="customPriceForm"
                         [isSuperAdmin]="isSuperAdmin"
                        ></app-common-summary-section>
                    </div>
                </div>
               
            </div> 
        </div>
    </div>
</div>
<app-review></app-review>
<app-checkout-footer></app-checkout-footer>
